/* global sr */

import Vue from 'vue';
import $ from 'jquery';
import da from 'vee-validate/dist/locale/da';
import VeeValidate, { Validator } from 'vee-validate';
import 'magnific-popup';
import VueShave from 'vue-shave';
import moment from 'moment';

import 'swiper/css/swiper.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueVideoSection from 'vue-video-section';

import { history } from '../plugins/history';
import { i18n } from '../translation.js';
import { trackFormView } from '../scripts/tag-manager';
import QdTabs from './tabs/tabs.js';
import QdIconTabs from './icon-tabs/icon-tabs.js';
import QdTabsContent from './tabs-content/tabs-content.js';
import QdTabContent from './tab-content/tab-content.js';
import QdCardFilter from './card-filter/card-filter.js';
import QdToggle from './toggle/toggle.js';
import QdToggleTrueFalse from './toggle-true-false/toggle-true-false.js';
import QdCardView from './card-view/card-view.js';
import QdSubjectGroupList from './subject-group-list/subject-group-list.js';
import QdBoxList from './box-list/box-list.js';
import QdBoxEl from './box-el/box-el.js';
import QdAccordionList from './accordion-list/accordion-list.js';
import QdAccordionEl from './accordion-el/accordion-el.js';
import QdSearch from './search/search.js';
import QdFileUpload from './file-upload/file-upload.js';
import QdEducationSignup from './education-signup/education-signup.js';
import QdCourseSubjectGroupSignup from './course-subject-group-signup/course-subject-group-signup.js';
import QdCourseSignup from './course-signup/course-signup.js';
import QdOpenPopup from './open-popup/open-popup.js';
import QdImageModel from './image-model/image-model.js';
import QdSocialfeed from './socialfeed/socialfeed.js';
import QdPromotion from './promotion/promotion.js';
import QdFaqList from './faq-list/faq-list.js';
import QdFaqEl from './faq-el/faq-el.js';

// Initialize siteData variable on window
window.siteData = window.siteData || {};

// Add site-wide data here:
const siteData = Object.assign(
	window.siteData,
	{
		qdEducationTabs: QdTabsContent.tabs,
		qdIsActive: false,
		qdPopup: null,
		qdIsNavOpen: false,
		qdScrollPosition: 0,
		qdHasStickyNav: false,
		qdShowStickyNav: false,
		qdHideElements: false,
		qdSignupSubmitStatus: '',
		qdShowAllEmployees: false,
		modalDepartment: [],
		showDepartmentModal: false,
		isMounted: false,
		showBanner: true,
		mountVideo: false,
	}
);

i18n.locale = siteData.language;

siteData.langClass = 'lang-' + siteData.language;

Vue.use( VueAwesomeSwiper );

// Add history plugin
Vue.use( history );

// Add locale helper.
Validator.addLocale( da );

// Install the Plugin and set the locale.
Vue.use( VeeValidate, {
	locale: siteData.language,
	dictionary: {
		en: {
			custom: {
				CivilRegistrationNumber: {
					regex: () => 'The CPR-number has to be in the following format: xxxxxx-xxxx',
				},
				CprNr: {
					regex: () => 'The CPR-number has to be in the following format: xxxxxx-xxxx',
				},
				DateOfBirth: {
					date_format: () => 'Date of birth has to be in the format: DDMMYY',
				},
			},
		},
		da: {
			custom: {
				terms: {
					required: () => 'Betingelserne skal accepteres',
				},
				CivilRegistrationNumber: {
					regex: () => 'CPR-nummeret skal have formatet: xxxxxx-xxxx',
				},
				CprNr: {
					regex: () => 'CPR-nummeret skal have formatet: xxxxxx-xxxx',
				},
				DateOfBirth: {
					date_format: () => 'Fødselsdato skal have formatet: DDMMÅÅ',
				},
			},
		},
	},
});
// add moment date validators to vee-validate
Validator.installDateTimeValidators( moment );

Vue.use( VueShave );

Vue.filter( 'stringTimeToMonthYear', function ( value ) {
	if ( !value ) {
		return '';
	} else {
		const fullDate = new Date( value );
		const orgDate = fullDate.getDate().toString();
		const orgMonth = ( fullDate.getMonth() + 1 ).toString();
		const year = fullDate.getFullYear().toString();
		const date = orgDate.length < 2 ? '0' + orgDate : orgDate;
		const month = orgMonth.length < 2 ? '0' + orgMonth : orgMonth;
		return date + '.' + month + '.' + year;
	}
});

Vue.filter( 'unixToDateMonthYear', function ( value ) {
	if ( !value ) {
		return '';
	} else {
		const fullDate = new Date( value * 1000 );
		const orgDate = fullDate.getDate().toString();
		const orgMonth = ( fullDate.getMonth() + 1 ).toString();
		const year = fullDate.getFullYear().toString();
		const date = orgDate.length < 2 ? '0' + orgDate : orgDate;
		const month = orgMonth.length < 2 ? '0' + orgMonth : orgMonth;
		return date + '.' + month + '.' + year;
	}
});

export default new Vue({
	el: '#root',
	data: siteData,
	components: {
		QdTabsContent,
		QdTabContent,
		QdTabs,
		QdIconTabs,
		QdCardFilter,
		QdToggle,
		QdToggleTrueFalse,
		QdCardView,
		QdSubjectGroupList,
		QdBoxList,
		QdBoxEl,
		QdAccordionList,
		QdAccordionEl,
		QdSearch,
		QdFileUpload,
		QdEducationSignup,
		QdCourseSubjectGroupSignup,
		QdCourseSignup,
		QdOpenPopup,
		QdSocialfeed,
		QdPromotion,
		QdFaqList,
		QdFaqEl,
		VueVideoSection,
		QdImageModel,
	},
	computed: {
		qdIsPopupActive() {
			return this.qdPopup !== null;
		},
	},
	watch: {
		qdPopup() {
			if ( this.qdPopup !== null ) {
				$.magnificPopup.open({
					items: {
						src: this.qdPopup.type,
					},
					type: 'inline',
					callbacks: {
						close: () => {
							this.qdPopup = null;
							this.qdSignupSubmitStatus = '';
						},
					},
				}, 0 );

				// TagManager
				if ( this.qdPopup.type === '.js-course-sign-up' ) {
					trackFormView( 'CourseSignup' );
				} else if ( this.qdPopup.type === '.js-education-sign-up' ) {
					trackFormView( 'EducationSignup' );
				} else if ( this.qdPopup.type === '.js-subject-group-sign-up' ) {
					trackFormView( 'CourseGroupSignup' );
				}

			}
		},
	},
	methods: {
		updateData( name, value ) {
			if ( process.env.NODE_ENV !== 'production' ) {
				console.log( name, value );
			}
			siteData[name] = value;
		},
		setActive() {
			siteData.qdIsActive = !siteData.qdIsActive;
		},
		toggleNav() {
			siteData.qdIsNavOpen = !siteData.qdIsNavOpen;
		},
		focusMobileSearch() {
			siteData.qdIsNavOpen = true;
			setTimeout( () => {
				document.getElementById( 'js-mobile-search' ).focus();
			}, 500 );
		},
		onScroll() {
			const currentScrollPosition = window.scrollY;
			siteData.qdHasStickyNav = currentScrollPosition > 500;
			siteData.qdShowStickyNav = currentScrollPosition < siteData.qdScrollPosition && currentScrollPosition !== 0 && !siteData.qdPopup;
			siteData.qdScrollPosition = currentScrollPosition;
		},
		openHoursModal( cityIndex, departmentIndex ) {
			siteData.showDepartmentModal = true;
			siteData.modalLocation = siteData.tabs[cityIndex];
			siteData.modalDepartment = siteData.tabs[cityIndex]['location_departments'][departmentIndex];
		},
		closeHoursModal() {
			siteData.showDepartmentModal = false;
			siteData.modalDepartment = [];
		},
	},
	i18n: i18n,
	created() {
		window.addEventListener( 'scroll', this.onScroll );
	},
	mounted() {
		sr.reveal( '.js-scroll-reveal', {
			easing: 'cubic-bezier( .395, .325, .365, .995 )',
			viewFactor: 0.6,
		});
		sr.reveal( '.js-scroll-reveal--static', {
			distance: 0,
			scale: 0,
		});
		sr.reveal( '.js-scroll-reveal--right', {
			origin: 'right',
		});
		sr.reveal( '.js-scroll-reveal--delay', {
			delay: 500,
		});
		sr.reveal( '.js-scroll-reveal--delay-250', {
			delay: 250,
		});
		sr.reveal( '.js-scroll-reveal--delay-1s', {
			delay: 1000,
		});
		sr.reveal( '.js-scroll-reveal--duration-1s', {
			duration: 1000,
		});
		sr.reveal( '.js-scroll-reveal--sequence', 20 );
		sr.reveal( '.js-scroll-reveal--sequence-50', 50 );
		sr.reveal( '.js-scroll-reveal--sequence-50-2', 50 );
		sr.reveal( '.js-scroll-reveal--sequence-50-3', 50 );

		this.$nextTick( function () {
			this.mountVideo = true;
			window.addEventListener( 'load', () => {
				let player = this.$refs['vue-video'];

				if ( player ) {
					this.$refs['vue-video'].playVideo().then( () => {

						this.$nextTick( function () {
							this.showBanner = false;
						});

					}
					);
				}
			});
		});

	},
	destroyed() {
		window.removeEventListener( 'scroll', this.onScroll );
	},
});




// WEBPACK FOOTER //
// ./assets/_js/components/root.js